
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { Baixa, BaixaValorTemp, BaixaInformacoes } from '@app/models/baixa.model';
import { LancamentoPesquisa } from '@app/pages/financeiro/lancamento/lancamento.model';
import { MovimentacaoFinanceira } from '@app/models/movimentacao-financeira.model';


@Injectable()
export class MovimentacaoService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  adicionar(movimentacao: MovimentacaoFinanceira): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'financeiro/movimentacao/', movimentacao).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  alterar(movimentacao: MovimentacaoFinanceira): Observable<any> {
    return this.http
      .put<any>(this.URL_API + 'financeiro/movimentacao/', movimentacao).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `financeiro/movimentacao/${id}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `financeiro/movimentacao/${id}`);
  }

  baixar(baixa: Baixa, baixaInformacoes: BaixaInformacoes, baixaCredito: boolean = false, devolucaoCredito: boolean = false): Observable<any> {
    baixaInformacoes.baixa = baixa;
    return this.http
      .post<any>(this.URL_API + `financeiro/baixa/baixar?baixaCredito=${baixaCredito}&devolucaoCredito=${devolucaoCredito}`, baixaInformacoes).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  baixarLista(baixas: Baixa[]): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `financeiro/baixa/baixarLista`, baixas).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  baixaValorTemp(baixaValorTemp: BaixaValorTemp): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `financeiro/baixa/baixaValorTemp`, baixaValorTemp).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterBaixaValorTemp(id: number, tipo: string): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `financeiro/baixa/obterBaixaValorTemp?id=${id}&tipo=${tipo}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }


  obterLancamentos(lancamentoPesquisa: LancamentoPesquisa): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `financeiro/movimentacao/obterLancamentos`, lancamentoPesquisa).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterResumoFinanceiro(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + 'financeiro/resumofinanceiro/obterresumo');
  }

}
